import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { ChatCircleText, MagnifyingGlass, Package, LockKey, Certificate } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STEPS = [
  { icon: ChatCircleText, title: "Describe your audience", body: "Use plain English or structured filters. Upload account lists or suppression files if you have them." },
  { icon: MagnifyingGlass, title: "Receive an estimate + sample", body: "Our team interprets your criteria, estimates the audience and provides a 20-row sample so you know what you're getting." },
  { icon: Package, title: "Choose your data quality", body: "Standard for speed and volume, Verified for freshly re-checked emails. You can request one revision before payment." },
  { icon: LockKey, title: "Approve & pay", body: "Payment is only required after you approve a quote. No subscription. No hidden fees." },
  { icon: Certificate, title: "Track & download securely", body: "Follow production and QA in real time. Download from a signed, time-limited link when it passes quality review." },
];

export default function HowItWorks() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <section className="section border-b border-border">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-3">Process</div>
          <h1 className="font-heading font-black tracking-tighter text-5xl md:text-6xl mb-6">How ExactReach works.</h1>
          <p className="text-lg text-muted-foreground max-w-2xl">
            No black-box search engine. Every request is reviewed by a research analyst, quoted, and only fulfilled after you approve.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {STEPS.map((s, i) => (
            <div key={s.title} className="grid md:grid-cols-[80px_1fr] gap-6 mb-12 anim-fade-up">
              <div className="font-mono text-3xl font-bold text-muted-foreground">0{i + 1}</div>
              <div>
                <s.icon size={26} weight="duotone" className="text-primary mb-3" />
                <h3 className="font-heading font-bold text-2xl mb-2">{s.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
          <div className="mt-16 border-t border-border pt-10">
            <Link to="/#query">
              <Button size="lg" className="rounded-sm h-12 px-6" data-testid="hiw-start-btn">Start a request</Button>
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
